export const scrollToHash = ({ hash }: { hash: string }) => {
  if (!hash) {
    return;
  }
  const el = document.querySelector(hash) as HTMLElement;
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
    });
  }
};

export const applySmoothScroll = () => {
  const linkEls: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('a[href*="#"]');
  linkEls.forEach((a) => {
    const { pathname } = new URL(a.href);
    if (pathname === window.location.pathname) {
      a.addEventListener('click', (event) => {
        event.preventDefault();
        scrollToHash({ hash: a.hash });
      });
    }
  });
};
